import React from 'react'
import { useSelector } from 'react-redux'
import EmptyTableView from '../../../universal/empty-table'
import DashboardTemplatesSMSTable from './table'
import './style.scss'
import { TableLoader } from '../../../library/table-loader'

const Index = ({searchQuery}) => {

	const smsTemplates = useSelector(state => state && state.templates.smsTemplates)
	const loading = useSelector(state => state.templates.fetchSmsTemplates.loading)


	return(
		<div className="sms-templates-container">
			<DashboardTemplatesSMSTable searchQuery={searchQuery}/>
			{loading ? <TableLoader/>:null}
            {!loading && smsTemplates.length === 0 ? <EmptyTableView title="Ingen maler lagt til" description="Her var det veldig tomt, men slapp helt av! Du kan enkelt legge til en ny mal ved å trykke på knappen øverst til høyre."/>:null}
        </div>
	)
}

export default Index
